import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Header from './components/Menu/Header';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUserEmail, setUserId } from './components/Login/loginSlice';
import { fetchUserFeatures } from './features/featuresSlice';
import { setStorageFiles } from './components/ChatApp/chatSlice';
import storageApi from './api/storageApi';
import assistantFile from './api/assistFilesApi';

function App() {
  const dispatch = useDispatch();
  const [chatType, setChatType] = useState('quick');
  useEffect(() => {
    const authData = localStorage.getItem('authData');
    if (authData) {
      const { userId, email, expiresAt } = JSON.parse(authData);
      if (Date.now() < expiresAt) {
        dispatch(setUserId(userId));
        dispatch(setUserEmail(email));
        // Загружаем features пользователя
        dispatch(fetchUserFeatures({ userId, email }));

        // Загружаем файлы хранилища для toggle
        const loadStorageFiles = async () => {
          try {
            const storagesRes = await storageApi.getUserStorages(userId);
            if (storagesRes?.data?.success && storagesRes.data.storages?.length > 0) {
              const storageId = storagesRes.data.storages[0].id;
              const filesRes = await assistantFile.listStorageFiles(storageId, userId);
              dispatch(setStorageFiles(filesRes.data || []));
            }
          } catch (err) {
            console.error("Ошибка при загрузке файлов хранилища:", err);
          }
        };
        loadStorageFiles();
      } else {
        localStorage.removeItem('authData');
      }
    }
  }, [dispatch]);
  return (
    <Router>
      {/* <Header setChatType={setChatType} /> */}
      <AppRoutes chatType={chatType} />
    </Router>
  );
}

export default App;
